import React, { Component } from "react";
import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import { toast, isMecanico } from "../../../utils/helpers";

import Form from "./Form";

class Create extends Component {
    state = {
        empleados: [],
        servicios: [],
        saving: false,
        errors: {},
    };

    componentDidMount() {
        this.getTable("empleados", "?estado=activos");
        this.getTable("servicios", "?vehiculo=" + this.props.vehiculo.id);
    }

    createRegistro = async (event) => {
        event.preventDefault();

        this.setState({
            saving: true,
        });

        const { vehiculoId } = this.state;
        const token = auth.getToken();
        const data = new FormData(event.target);

        const url = `vehiculos/${vehiculoId}/servicios`;

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            document.getElementById("serviciosform").reset();
            this.props.toggle(null, response.data, true);
            toast("Servicio registrado exitosamente.");
            if (this.props.getRegistros) {
                this.props.getRegistros();
            }
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({
            saving: false,
        });
    };

    getTable = async (url = null, params = "") => {
        const table = await this.props.request(url + params);

        if (table.data && table.data.length > 0) {
            this.setState({
                [url]: table.data,
            });
        }
    };

    render() {
        const { vehiculo, registro } = this.props;
        const { empleados, servicios, errors } = this.state;

        const mecanicos = empleados.filter((empleado) =>
            isMecanico(empleado.cargo)
        );

        return (
            <form
                id='serviciosform'
                method='post'
                onSubmit={this.createRegistro}>
                <input type='hidden' name='_method' value='post' />
                <div className='popup__header'>
                    Registrar Servicio para {vehiculo.ficha}
                </div>
                <div className='popup__body'>
                    <Form
                        vehiculo={vehiculo}
                        mecanicos={mecanicos}
                        servicios={servicios}
                        registro={registro}
                        errors={errors}
                    />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={() => this.props.toggle()}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {this.state.saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Crear
                        </button>
                    )}
                </div>
            </form>
        );
    }
}

export default withRequest(Create);
